import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';

const ChatFooter = ({ onLanguageClick }) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { t } = useLanguage();

  const handleLanguageClick = (e) => {
    e.preventDefault();
    if (onLanguageClick) {
      onLanguageClick();
    }
  };

  return (
    <div className="chat-footer" style={{
      background: theme.secondaryBg,
      borderTop: `1px solid ${theme.primaryBorder}`,
      padding: '16px 32px',
      textAlign: 'center'
    }}>
      <div className="footer-links" style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '24px'
      }}>
        <Link to="/privacy" style={{
          color: theme.tertiaryText,
          textDecoration: 'none',
          fontSize: '14px',
          transition: 'color 0.2s ease'
        }} onMouseEnter={e => e.target.style.color = theme.secondaryText}
           onMouseLeave={e => e.target.style.color = theme.tertiaryText}>{t('footer.privacy')}</Link>
        <a 
          href="#language" 
          onClick={handleLanguageClick}
          style={{
            color: theme.tertiaryText,
            textDecoration: 'none',
            fontSize: '14px',
            transition: 'color 0.2s ease',
            cursor: 'pointer'
          }} 
          onMouseEnter={e => e.target.style.color = theme.secondaryText}
          onMouseLeave={e => e.target.style.color = theme.tertiaryText}
        >
{t('common.language')}
        </a>
        <a 
          href="mailto:roger@oaklandvnchamber.com?subject=Help Request - Oakland AI Assistant" 
          style={{
            color: theme.tertiaryText,
            textDecoration: 'none',
            fontSize: '14px',
            transition: 'color 0.2s ease'
          }} 
          onMouseEnter={e => e.target.style.color = theme.secondaryText}
          onMouseLeave={e => e.target.style.color = theme.tertiaryText}
          title="Send email to roger@oaklandvnchamber.com for help"
        >
{t('footer.help')}
        </a>
        <a 
          href="/developer"
          onClick={(e) => {
            e.preventDefault();
            // Check #4: CRITICAL - Verify DeveloperPage route exists before navigation
            try {
              navigate('/developer');
            } catch (error) {
              // CRITICAL ERROR: DeveloperPage route is missing
              console.error('❌ CRITICAL ERROR: Cannot navigate to /developer - DeveloperPage is required!', error);
              alert('CRITICAL ERROR: DeveloperPage is required but missing. The application cannot function without it. Please restore frontend/src/pages/DeveloperPage.jsx');
              throw new Error('DeveloperPage route is required but missing');
            }
          }}
          style={{
            color: theme.tertiaryText,
            textDecoration: 'none',
            fontSize: '14px',
            transition: 'color 0.2s ease',
            cursor: 'pointer'
          }} 
          onMouseEnter={e => e.target.style.color = theme.secondaryText}
          onMouseLeave={e => e.target.style.color = theme.tertiaryText}
        >
          {t('navigation.developer')}
        </a>
      </div>
    </div>
  );
};

export default ChatFooter; 